import { throttle } from 'utils/decorators';

const getClientWidth = throttle(() => {
	return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}, 200);
export default getClientWidth;
